import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGTag from "vue-gtag";

import RegistrarProductor from '../views/RegistrarProductor.vue'
import Calendario from '../views/Calendario.vue'
import RegistroComprador from '../views/RegistroComprador.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/registro',
    name: 'RegistroProductor',
    component: RegistrarProductor,
    meta: {
      title: 'Registro Productor - Cultivando Futuro'
    }
  },
  {
    path: '/registro-comprador',
    name: 'RegistroComprador',
    component: RegistroComprador,
    meta: {
      title: 'Registro Comprador - Cultivando Futuro'
    }
  },
  {
    path: '/',
    name: 'Calendario',
    component: Calendario,
    meta: {
      title: 'Calendario Producción - Cultivando Futuro'
    }
  }
]

const router = new VueRouter({
  mode:'hash',
  base: process.env.BASE_URL,
  routes
})

Vue.use(VueGTag, {
  config: { id: "UA-164240644-1" },
  appName: 'Calendario Cultivando Futuro',
  pageTrackerScreenviewEnabled: true
}, router);

router.beforeEach((to, from, next) => {
  const Title = to.meta.title;
  if (Title) document.title = Title;
  next();
});

export default router
